<template>
  <div class="workflow" v-if="$can('workflow_step_conditions_view')">
    <v-snackbar v-model="snackbar" :timeout="4000" top :color="color">
      <span>{{ message }}</span>
    </v-snackbar>
    <v-container>
      <v-layout column>
        <v-flex xs12>
          <h1>Workflow Step Conditions</h1>
          <v-breadcrumbs>
            <v-breadcrumbs-item disabled v-if="dashBreadcrumb">
              Dashboard</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider >/</v-breadcrumbs-divider>
            
            <v-breadcrumbs-item @click="$router.push('workflow')"><a>Workflow</a></v-breadcrumbs-item>
            <v-breadcrumbs-divider >/</v-breadcrumbs-divider>
            <v-breadcrumbs-item @click="$router.push('workflownodes')"><a>Nodes</a></v-breadcrumbs-item>
            <v-breadcrumbs-divider >/</v-breadcrumbs-divider>
            <v-breadcrumbs-item @click="$router.push('workflowsteps')"><a>Steps</a></v-breadcrumbs-item>
            <v-breadcrumbs-divider >/</v-breadcrumbs-divider>
            <v-breadcrumbs-item disabled >Conditions</v-breadcrumbs-item>
            <v-breadcrumbs-divider v-if="!dashBreadcrumb"
              >/</v-breadcrumbs-divider
            >
            <v-breadcrumbs-item disabled v-if="showBreadcrumb">
              View workflow step conditions</v-breadcrumbs-item
            >
          </v-breadcrumbs>
        </v-flex>
        <div v-if="view == 'default'">
          <v-flex xs12 class="mt-5 mb-2">
            <div class="mx-5">
              <v-layout row wrap>
                <v-flex xs12 md4 class="hidden-sm-and-down"> </v-flex>

                <v-flex xs12 md4>
                  <div class="pa-1">
                    <v-text-field
                      class="text_field header"
                      outlined
                      dense
                      label="Search"
                      v-on:keyup.enter="search"
                      v-model="searchTerm"
                      @input="enableSearch()"
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 md2>
                  <div class="pa-1">
                    <v-btn
                      class="secondary text-none"
                      depressed
                      block
                      @click="search"
                      :loading="searchLoader"
                      :disabled="searchButtonDisabled"
                    >
                      Search
                      <v-icon right>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12 md2 class="hidden-sm-and-down"> </v-flex>
              </v-layout>
            </div>
          </v-flex>

          


          <v-divider class="mt-5 mx-5"></v-divider>
          <v-flex xs12 class="mt-5">
            <div align="right">
              <v-btn
                depressed
                class="accent text-none"
                @click="changeView('create')"
                v-if="$can('workflow_step_conditions_create')"
              >
                Add workflow step condition
                <v-icon right> mdi-plus-circle-outline </v-icon>
              </v-btn>
            </div>
          </v-flex>
          <v-flex xs12 class="mt-5">
            <div v-if="workflowcondition.length == 0">
              <v-card elevation="0">
                <v-layout row wrap>
                  <v-flex xs12 md1>
                    <v-container fill-height fluid>
                      <v-row align="center" justify="center">
                        <v-col class="text-center">
                          <v-icon large class="primary--text">
                            mdi-alert-circle-outline
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 md11>
                    <v-container fill-height fluid>
                      <v-row align="center" justify="center">
                        <v-col class="text-center"> No workflow node found.. </v-col>
                      </v-row>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-card>
            </div>
            <div v-else>
              <v-progress-linear
                v-if="workflowconditionLoader"
                height="1"
                indeterminate
                color="primary"
              ></v-progress-linear>
              <div class="hidden-sm-and-down">
                <v-card elevation="0" class="pa-2">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr class="primary white--text">                         
                          <th class="text-left white--text">Workflow Next Step</th>
                          <th class="text-left white--text">Logic</th>
                          <th class="text-left white--text">Column Name</th>
                          <th class="text-left white--text">Operator</th>
                          <th class="text-left white--text">Value</th>
                     
                          <th class="text-right white--text">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in filterConditions(workflowcondition)" :key="item.id">
                          <td>{{ formData.workflownextstep.find(e => e.id === item.workflow_next_step_id).currentnode.node_name  }}</td>
                          <td>{{ item.logic }}</td>
                          <td>{{ item.column_name }}</td>
                          <td>{{ item.operator }}</td>
                          <td>{{ item.value }}</td>

                          <td>
                            <div align="right">
                              <v-tooltip top v-if="$can('workflow_step_conditions_view')">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon @click="showworkflow(item)" class="button mr-1 primary--text" v-bind="attrs" v-on="on">
                                          <v-icon small>
                                              mdi-eye
                                          </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{ $t('viewMsg') }}</span>
                              </v-tooltip>
                              <v-tooltip top v-if="$can('workflow_step_conditions_edit')">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon @click="editworkflow(item)" class="button mr-1 success--text" v-bind="attrs" v-on="on">
                                          <v-icon small>
                                              mdi-pencil
                                          </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{ $t('editMsg') }}</span>
                              </v-tooltip>
                              <v-tooltip top v-if="$can('workflow_step_conditions_archive')">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon @click="deleteworkflow(item)" :loading="loading && workflowconditionIndex == item.id" class="button error--text" v-bind="attrs" v-on="on">
                                          <v-icon small>
                                              mdi-delete
                                          </v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{ $t('deleteMsg') }}</span>
                              </v-tooltip>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </div>
              <div class="hidden-md-and-up">
                <v-layout column>
                  <template v-for="(workflow, index) in workflowcondition">
                    <div :key="index">
                      <v-flex xs12 class="mb-2">
                        <v-card elevation="0">
                          <div class="pa-5">
                            <v-layout column>
                              <v-flex xs12>
                                <v-layout row wrap>
                                  <v-flex xs11>
                                    <div class="title primary--text">
                                      <b>{{ workflow.node_name }}</b>
                                    </div>
                                  </v-flex>
                                  <v-flex xs1>
                                    <v-btn
                                      depressed
                                      class="red--text"
                                      :loading="
                                        loading && workflowconditionIndex == workflow.id
                                      "
                                      icon
                                      @click="deleteworkflow(workflow)"
                                      v-if="$can('workflow_step_conditions_archive')"
                                    >
                                      <v-icon> mdi-delete </v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-divider class="mt-2"></v-divider>
                              <v-flex xs12 class="mt-1">
                                <v-layout column>
                                  <v-flex xs12 class="mt-1">
                                    <div><b>Workflow Next Step</b></div>
                                    <div>{{ workflow.workflow_next_step_id }}</div>
                                  </v-flex>
                                  <v-flex xs12 class="mt-1"> </v-flex>
                                  <v-flex xs12 class="mt-5">
                                    <v-layout row wrap>
                                      <v-flex xs12>
                                        <div class="pa-1">
                                          <v-btn
                                            depressed
                                            class="
                                              primary
                                              text-none
                                              white--text
                                            "
                                            block
                                            @click="showworkflow(workflow)"
                                            v-if="$can('workflow_step_conditions_view')"
                                            >View
                                            <v-icon right> mdi-eye </v-icon>
                                          </v-btn>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12>
                                        <div class="pa-1">
                                          <v-btn
                                            depressed
                                            class="
                                              green
                                              darken-1
                                              text-none
                                              white--text
                                            "
                                            block
                                            @click="editworkflow(workflow)"
                                            v-if="$can('workflow_step_conditions_edit')"
                                            >Edit
                                            <v-icon right>
                                              mdi-border-color
                                            </v-icon>
                                          </v-btn>
                                        </div>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-card>
                      </v-flex>
                    </div>
                  </template>
                </v-layout>
              </div>
            </div>
          </v-flex>
          <v-flex xs12 class="mt-5">
            <v-layout row wrap>
              <v-flex xs12 md3>
                <div v-if="length != 0">
                  <b class="primary--text ml-4">Total: </b
                  >{{ filterConditions(workflowcondition).length | formatNumber }}
                </div>
              </v-flex>
              <v-flex xs12 md9>
                <div align="right">
                  <v-pagination
                    v-if="length != 0 && length != 1"
                    :length="length"
                    total-visible="10"
                    v-model="workflowconditionPagination.current_page"
                    @input="changePage()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </div>
        <div v-if="view == 'create'">
          <v-flex class="mt-5">
            <v-card elevation="0">
              <v-card-title class="primary white--text">
                <v-spacer></v-spacer>
                <div v-if="workflow_condition.id == null">Add workflow step conditions</div>
                <div v-else>Edit workflow condition</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="changeView('default')">
                  <v-icon class="white--text"> mdi-close </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-layout row wrap class="mt-5">
                 
                    <v-flex xs12 md4>
                      <div class="pa-3">
                        <div>Workflow Next Step*</div>
                        <v-select
                          :items="formData.workflownextstep"
                          v-model="$store.state.currentStep"
                          class="text_field background"
                          item-value="id"
                          item-text="currentnode.node_name"
                          outlined
                          readonly
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>

                    <v-flex xs12 md4>
                      <div class="pa-3">
                        <div>Model Name*</div>
                        <v-select
                          :items="currentModel"
                          v-model="workflow_condition.model_name"
                          class="text_field background"
                          item-value="model_name"
                          item-text="application_name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>

                    <v-flex xs12 md4>
                      <div class="pa-3">
                        <div>Logic*</div>
                        <v-select
                          :items="logic"
                          v-model="workflow_condition.logic"
                          class="text_field background"
                          item-value="name"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>

                 <v-flex xs12 md4 v-if="workflow_condition.model_name == 'App\\Models\\BusinessPermit' ">
                      <div class="pa-3">
                        <div>Column Name*</div>
                        <v-select
                          :items="formData.BusinessPermit"
                          v-model="workflow_condition.column_name"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex> 

                 <v-flex xs12 md4 v-if="workflow_condition.model_name == 'App\\Models\\BuildingApplication' ">
                      <div class="pa-3">
                        <div>Column Name*</div>
                        <v-select
                          :items="formData.BuildingApplication"
                          v-model="workflow_condition.column_name"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex> 
                    
                 <v-flex xs12 md4 v-if="workflow_condition.model_name == 'App\\Models\\HouseApplication' ">
                      <div class="pa-3">
                        <div>Column Name*</div>
                        <v-select
                          :items="formData.HouseApplication"
                          v-model="workflow_condition.column_name"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>                     
                 <v-flex xs12 md4 v-if="workflow_condition.model_name == 'App\\Models\\PropertyApplication' ">
                      <div class="pa-3">
                        <div>Column Name*</div>
                        <v-select
                          :items="formData.PropertyApplication"
                          v-model="workflow_condition.column_name"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex> 

                    <v-flex xs12 md4>
                      <div class="pa-3">
                        <div>Operator*</div>
                        <v-select
                          :items="operator"
                          v-model="workflow_condition.operator"
                          class="text_field background"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          :rules="inputRules"
                        ></v-select>
                      </div>
                    </v-flex>

                    <v-flex xs12 md4>
                      <div class="pa-3">
                        <div>Value*</div>
                        <v-text-field
                          class="text_field background"
                          outlined
                          dense
                          v-model="workflow_condition.value"
                          :rules="inputRules"
                        ></v-text-field>
                      </div>
                    </v-flex>

                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  class="secondary text-none mt-3"
                  @click="save"
                  :disabled="!valid"
                  :loading="loading"
                >
                  Save
                  <v-icon right> mdi-content-save </v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </div>
        <div v-if="view == 'show'">
          <v-card elevation="0" class="pa-3">
            <div><b>Workflow Next Step: </b>{{ assignedworkflow.workflow_next_step }}</div>
            <div><b>Logic: </b>{{ assignedworkflow.logic }}</div>
            <div><b>Model: </b>{{ assignedworkflow.model_name }}</div>
            <div><b>Column Name: </b>{{ assignedworkflow.column_name }}</div>
            <div><b>Operator: </b>{{ assignedworkflow.operator }}</div>
            <div><b>Value: </b>{{ assignedworkflow.value }}</div>

            <!-- <div><b>Guard Name: </b>{{ assignedworkflow.workflow_mapping_id }}</div>
            <div class="mt-3"><b>Permissions</b></div> -->
            
          </v-card>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import apiCall from "@/utils/api";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
var numeral = require("numeral");
Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0");
});
Vue.filter("formatMoney", function (value) {
    return numeral(value).format("0,0.00");
});
export default {
  components: {},
  data() {
    return {
      dashBreadcrumb: true,
      showBreadcrumb: false,

      view: "default",
      page: 1,
      loading: false,
      valid: true,
      message: "",
      color: "",
      delete: false,
      workflowconditionIndex: null,
      snackbar: false,
      inputRules: [
        v => !!v || 'Input is required',
      ],

      inputRules_SpecCharac: [
        v => !!v || 'Input is required',
        v => !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(v) || 'Must not have any special character'
      ],
      searchTerm: null,
      searchLoader: false,
      searchButtonDisabled: false,
      formData:null,
      workflows:[],
      BuildingApplication:[],
      filteredworkflowcondition: false,
      searchButtonDisabled: false,
      logic:[
        { id:0 , name: "AND" },
        { id:1 , name: "OR" },

      ],

      operator:[
        { id:'=' , name: "EQUALS (=)" },
        { id:'<' , name: "LESS THAN (<)" },
        { id:'>' , name: "GREATER THAN (>)" },
        { id:'>=' , name: "GREATER THAN OR EQUALS (>=)" },
        { id:'<=' , name: "LESS THAN OR EQUALs (<=)" },
        { id:'!=' , name: "NOT EQUALS (!=)" },

      ],
      model:{

      name:null

      },
      workflow_condition: {
        id: null,
        workflow_next_step_id: null,
        logic: null,
        column_name:null,
        operator:null,
        value:null,

      },
      assignedworkflow: {
        workflow_next_step_id: null,
        logic: null,
        model_name: null,
        column_name:null,
        operator:null,
        value:null,
        workflownextstep:[],
      },

      currentModel:{
        model_name: null,
        application_name: null,
      },
    };
  },
  created() {
    if(this.$can('workflow_step_conditions_view')){
      this.fetchworkflowcondition(this.workflowconditionPagination.current_page);
      this.getFormData();
    }
  },
  methods: {
    ...mapActions([
      "fetchworkflowcondition",
      "startworkflowconditionLoader",
      "stopworkflowconditionLoader",
      "filterworkflowcondition",
    ]),
    enableSearch() {
      this.searchButtonDisabled = false;
    },
    filterConditions(workflow_step){
      const id = this.$store.state.currentStep;
      return  workflow_step.filter((a)=>{if(a.workflownextstep.id == id){return a;}});
    },
    
    showworkflow(workflow) {

      this.assignedworkflow.workflow_next_step = workflow.workflownextstep.currentnode.node_name;
      this.assignedworkflow.logic = workflow.logic;
      this.assignedworkflow.model_name = workflow.model_name;
      this.assignedworkflow.column_name = workflow.column_name;
      this.assignedworkflow.operator = workflow.operator;
      this.assignedworkflow.value = workflow.value;
      this.changeView("show");
    },
    editworkflow(workflow) {
      
      this.workflow_condition.id = workflow.id;   
      this.workflow_condition.workflow_next_step_id = workflow.workflow_next_step_id;
      this.workflow_condition.logic = workflow.logic;
      this.workflow_condition.model_name = workflow.model_name;
      this.workflow_condition.column_name = workflow.column_name;
      this.workflow_condition.operator = workflow.operator;
      this.workflow_condition.value = workflow.value;

      this.changeView("create");
    },

    getFormData() {
      apiCall({
        url: "/api/workflowstepcondition?type=formData",
        method: "GET",
      })
        .then((resp) => {
          this.formData = resp;

          if(resp.workflownextstep.length > 0){
            this.currentModel.model_name = resp.workflownextstep[0].currentnode.workflow.mapping.model_name;
            this.currentModel.application_name = resp.workflownextstep[0].currentnode.workflow.mapping.application_name;   
            this.workflow_condition.model_name = this.currentModel.model_name;        
          }
        })
        .catch((error) => {
          this.message = "An error occurred; Couldn't get Form Data";
          this.color = "error";
        });
    },

    save() {
        this.workflow_condition.workflow_next_step_id = this.$store.state.currentStep;
        if (this.$refs.form.validate()) {
          this.loading = true;
          if (this.workflow_condition.id != null) {
            apiCall({
              url: "/api/workflowstepcondition/" + this.workflow_condition.id,
              data: this.workflow_condition,
              method: "PUT",
            })
              .then((resp) => {
                this.message = "Workflow updated successfully.";
                this.color = "orange";
                this.loading = false;
                this.snackbar = true;
                this.changeView("default");
                this.fetchworkflowcondition(1);
              })
              .catch((error) => {
                this.message = "An error occurred.";
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
              });
          } else {
            apiCall({
              url: "/api/workflowstepcondition",
              data: this.workflow_condition,
              method: "POST",
            })
              .then((resp) => {
                this.message = "Workflow Added Successfully.";
                this.color = "success";
                this.loading = false;
                this.snackbar = true;
                this.changeView("default");
                this.fetchworkflowcondition(1);
              })
              .catch((error) => {
                this.message = "An error occurred.";
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
              });
          }
        }
      
    },
    search() {
      if (this.searchTerm == null) {
        this.searchButtonDisabled = true;
      } else {
        this.searchLoader = true;
        this.searchButtonDisabled = false;
        this.startworkflowconditionLoader();
        apiCall({
          url: "/api/workflowstepcondition?type=search&search=" + this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filterworkflowcondition(resp);
            this.searchLoader = false;
            this.stopworkflowconditionLoader();
            this.filteredworkflowcondition = true;
          })
          .catch((error) => {
            console.log(error.response);
            this.searchLoader = false;
            this.stopworkflowconditionLoader();
            this.message = "An error occurred";
            this.color = "error";
            this.snackbar = true;
          });
      }
    },
    changeView(view) {
      if (view == "default") {
        this.workflow_condition.id = null;
        this.workflow_condition.workflow_name = null;
        this.workflow_condition.workflow_mapping_id = null;
        this.dashBreadcrumb = true;
        this.showBreadcrumb = false;
      } else if (view == "create") {
        
      } else if (view == "show") {
        this.dashBreadcrumb = false;
        this.showBreadcrumb = true;
      }
      this.view = view;
    },
    changePage() {
      if (this.filteredworkflowcondition == true) {
        this.searchButtonDisabled = false;
        this.startworkflowconditionLoader();
        apiCall({
          url:
            "/api/workflowstepcondition?page=" +
            this.workflowconditionPagination.current_page +
            "&type=search&search=" +
            this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filterworkflowcondition(resp);
            this.stopworkflowconditionLoader();
          })
          .catch((error) => {
            console.log(error.response);
            this.stopworkflowconditionLoader();
            this.message = "An error occurred";
            this.color = "error";
            this.snackbar = true;
          });
      } else {
        this.fetchworkflowcondition(this.workflowconditionPagination.current_page);
      }
    },
    deleteworkflow(item) {
      confirm("Are you sure you want to delete workflow?") &&
        (this.delete = true);
      if (this.delete) {
        this.loading = true;
        this.workflowconditionIndex = item.id;
        apiCall({ url: "/api/workflowstepcondition/" + item.id, method: "DELETE" })
          .then((resp) => {
            this.message = "workflow Deleted Succesfully";
            this.color = "success";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.workflowconditionIndex = null;
            this.fetchworkflowcondition(this.workflowconditionPagination.current_page);
          })
          .catch((error) => {
            this.message = "Something went wrong";
            this.color = "error";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.workflowconditionIndex = null;
            console.log(error.response);
          });
      }
    },
  },
  computed: {
    ...mapGetters([

      "workflowcondition",
      "workflowconditionPagination",
      "workflowconditionLoader",
    ]),
    length: function () {
      return Math.ceil(
        this.workflowconditionPagination.total / this.workflowconditionPagination.per_page
      );
    },
  },
};
</script>